export default {
  ToolList: [
    {
      key: 'Previous',
      displayName: 'report.winloseSimple.tool.previous',
    },
    {
      key: 'Today',
      displayName: 'report.winloseSimple.tool.today',
    },
    {
      key: 'Yesterday',
      displayName: 'report.winloseSimple.tool.yesterday',
    },
    {
      key: 'This Week',
      displayName: 'report.winloseSimple.tool.this_week',
    },
    {
      key: 'Last Week',
      displayName: 'report.winloseSimple.tool.last_week',
    },
    {
      key: 'This Month',
      displayName: 'report.winloseSimple.tool.this_month',
    },
    {
      key: 'Last Month',
      displayName: 'report.winloseSimple.tool.last_month',
    },
    {
      key: 'Next',
      displayName: 'report.winloseSimple.tool.next',
    },
  ],
};
